<template>
  <div class="tickets">
    <div class="tickets__items pretty-scrollbar">
      <BaseMenuItem
        v-for="(item, i) in items"
        :key="`tickets_item_${i}`"
        :label="getLabel(item)"
        class="tickets__item"
        @click="$emit('pick', item)"
      />
    </div>
    <footer v-if="note" class="tickets__footer">
      <BaseText
        v-bind="note"
        class="tickets__note"
      />
    </footer>
  </div>
</template>

<script>
import BaseText from '@/components/BaseText.vue';
import BaseMenuItem from '@/components/BaseMenuItem.vue';

export default {
  name: 'Tickets',
  components: {
    BaseText,
    BaseMenuItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    note: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getLabel(item) {
      const sum = this.$options.filters.sum(item.price);
      return {
        text: `${item.name}<span class="tickets__sum">${sum}</span>`,
        size: 'm',
      };
    },
  },
};
</script>

<style lang="stylus">
.tickets
  display block
  position relative

  &__items
    display flex
    flex-wrap wrap
    justify-content center
    align-items center
    height 100%
    padding-top 1em
    padding-bottom 8em
    padding-right 'calc((%s - %s) + 0.3em)' % ($side_padding ($scroll_width * 1px))

  &__item
    flex 0 0 50%
    max-width calc(50% - 0.5em)
    margin-right 0.5em
    height 8em
    &:nth-child(2n)
      margin-left 0.5em
      margin-right 0
    &:not(:nth-child(-n+2))
      margin-top 1em
    &:only-child
      margin 0

  &__sum
    display block
    font-weight 400
    font-family $font_primary
    letter-spacing 0
    margin-top 0.5em

  &__footer
    abs bottom left right
    background-color alpha($c_bg, 80%)
    padding-right $side_padding
    // padding-top 0.5em
    z-index 3
</style>
